/* istanbul ignore file */

export const IllusBowlEmptySmall = [
  require('./Illus-BowlEmpty-Small.png'),
  require('./Illus-BowlEmpty-Small@2x.png'),
];
